import styles from './SideMenuLayout.module.scss';
import AnotherSolutionIcon from "Assets/SVG/AnotherSolutionIcon";
import {cloneElement, ReactElement, ReactNode, useState} from "react";
import { Link, useMatch } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PeopleIcon from "Assets/SVG/PeopleIcon";
import HandsIcon from "Assets/SVG/HandsIcon";
import GuitarIcon from "Assets/SVG/GuitarIcon";
import OrdersIcon from "Assets/SVG/OrdersIcon";
import PrintIcon from "Assets/SVG/PrintIcon";
import InventoryIcon from "Assets/SVG/InventoryIcon";
import CalculatorIcon from "../Assets/SVG/CalculatorIcon";
import moment from 'moment';
import SmallCaret from "../Assets/SVG/SmallCaret";
import TagIcon from "../Assets/SVG/TagIcon";
import {useUserContext} from "../Apis/UserContextApi";
import {canAccess} from "../Utils/CanAccess";
import UserProvider from "../Providers/UserContextProvider";
import i18n from "Translations";

interface IProps {
    children: ReactNode;
}
const SideMenuLayout = (props: IProps) => {
    
    const { t } = useTranslation();

    const { data: userContext } = useUserContext();

    const [open, setOpen] = useState<boolean>(true)

    const { children } = props;
    
    const getBiUrl = () => {
        return `/bi?display=Order&statusDate=Received&from=${moment().startOf('month').format('YYYY-MM-DD')}&to=${moment().endOf('month').format('YYYY-MM-DD')}`;
    }
    
    if (!userContext) {
        return <></>
    }
    
    return (
        <UserProvider>
            <div className={`${styles.layout} ${(open) && styles.open}`}>
                <div className={`${styles.menu}`}>
                    <div className={styles.toggle} onClick={_ => setOpen(current => !current)}>
                        <SmallCaret direction={"ASCENDING"} style={{transform: `rotate(${open ? 90 : -90}deg)`}} fill={"white"} />
                    </div>
                    <div className={`${styles.logoContainer} ${(open) && styles.open}`}>
                        <AnotherSolutionIcon />
                    </div>
                    <div className={`${(open) && styles.menuOpen}`}>
                        {canAccess(userContext.permissions, 'Admin') ? (
                            <>
                                <MenuItem to={"/orders?page=0&status=Open&reverseTagSearch=false"} text={t('orders')} icon={<OrdersIcon />} matchUrl={"orders"} />
                                <MenuItem to={getBiUrl()} text={t('bi.bi')} icon={<CalculatorIcon />} matchUrl={"/bi"} />
                                <MenuItem to={"/settlements"} text={t('settlements')} icon={<CalculatorIcon />} matchUrl={"settlements"} />
                                <MenuItem to={"/customers?page=0"} text={t('customers')} icon={<HandsIcon />} matchUrl={"customers"} />
                                <MenuItem to={"/projects?page=0"} text={t('projects')} icon={<GuitarIcon />} matchUrl={"projects"} />
                                <MenuItem to={"/partners?page=0"} text={t('partners')} icon={<HandsIcon />} matchUrl={"partners"} />
                                <MenuItem to={"/products?page=0&readyForUse=true"} text={t('products')} icon={<InventoryIcon />} matchUrl={"products"} />
                                <MenuItem to={"/designs?page=0&listed=true"} text={t('designs')} icon={<PrintIcon />} matchUrl={"designs"} />
                                <MenuItem to={"/prints?page=0&listed=true"} text={t('prints')} icon={<PrintIcon />} matchUrl={"prints"} />
                                <MenuItem to={"/tags?page=0"} text={t('tags')} icon={<TagIcon />} matchUrl={"tags"} />
                                <MenuItem to={"/users?page=0"} text={t('users')} icon={<PeopleIcon />} matchUrl={"users"} />
                            </>
                        ) : (
                            <>
                                <MenuItem to={`/settlements/settlementResult?from=${moment().startOf('month').format('YYYY-MM-DD')}&to=${moment().endOf('month').format('YYYY-MM-DD')}`} text={t('settlements')} icon={<CalculatorIcon />} matchUrl={"settlements/settlementResult"} />
                                <MenuItem to={`/settlements/settlementSales?showType=orders&from=${moment().startOf('month').format('YYYY-MM-DD')}&to=${moment().endOf('month').format('YYYY-MM-DD')}`} text={t('sales')} icon={<CalculatorIcon />} matchUrl={"settlements/settlementSales"} />
                                <MenuItem to={`/settlements/zettleSales?from=${moment().startOf('month').format('YYYY-MM-DD')}&to=${moment().endOf('month').format('YYYY-MM-DD')}`} text={t('zettleSales')} icon={<CalculatorIcon />} matchUrl={"settlements/zettleSales"} />
                            </>
                        )}
                    </div>
                    <div>
                        <div className={`${styles.languageSwitcher} ${!open && styles.closed}`}>
                            <div className={`${styles.language} ${i18n.language === 'da' && styles.active}`} onClick={() => i18n.changeLanguage('da')}>
                                DA
                            </div>
                            <div className={`${styles.language} ${i18n.language === 'en' && styles.active}`} onClick={() => i18n.changeLanguage('en')}>
                                EN
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.content}>
                    {children}
                </div>
            </div>
        </UserProvider>
    )
}

interface IMenuItemProps {
    to: string;
    matchUrl?: string;
    text: string;
    icon: ReactElement;
}
const MenuItem = (props: IMenuItemProps) => {
    
    const { to, matchUrl, text, icon } = props;
    
    const match = useMatch({ path: matchUrl ?? to, end: false })
    
    return (
        <Link to={to} className={`${styles.menuItem} ${match && styles.active} `}>
            <div className={styles.icon}>
                {cloneElement(icon, { fill: match ? "#E91D25" : "#707070"})}
            </div>
            <span className={styles.text}>
                {text}
            </span>
        </Link>
    )
}

export default SideMenuLayout
